var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-color",class:{
    select: _vm.select,
    disabled: _vm.disabled,
  },style:(_vm.customStyle),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isShowCancelIcon)?_c('v-icon',{attrs:{"color":"red"}},[_vm._v(" mdi-cancel ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }